import Raffle from "@/views/editor/service/raffle/raffle/index";
import {INewBusiness} from "@/views/editor/service/business";

export default {'raffle': Raffle} as { [key: string]: INewBusiness }